import * as actionTypes from './../actions/actionTypes';

const initial2FADetailsState = {
  method2FADetails: null,
  code2FADetails: null,
};

const initialState = {
  access_token: null,
  expires_in: null,
  refresh_token: null,
  token_type: null,
  auth_type: null,
  auth_date: null,
  in_progress: true, // at page load this will be true because seing if the user is logged in is the first thing we check
  accountProblemModal: false,
  accountProblemCode: 0,
  accountProblemMessage: null,
  globalAuthenticationError: null,
  ...initial2FADetailsState
};


const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.authentication.AUTHENTICATE:
      return {
        ...state,
        ...initial2FADetailsState,
        access_token: action.accessToken,
        expires_in: action.expiresIn,
        refresh_token: action.refreshToken,
        token_type: action.tokenType,
        auth_type: action.authType,
        auth_date: action.authDate,
        in_progress: false,
        // method2FADetails: null,

      };
    case actionTypes.authentication.CLEAR:
      return {
        ...initialState,
        method2FADetails: state.method2FADetails,
      };
    case actionTypes.authentication.ACCOUNT_PROBLEM:
      return {
        ...state,
        accountProblemModal: action.show,
        accountProblemCode: action.code,
        accountProblemMessage: action.message,
      };
    case actionTypes.authentication.SET_GLOBAL_ERROR:
      return {
        ...state,
        globalAuthenticationError: action.data,
        in_progress: false,
      };
    case actionTypes.login.REQUEST_AUTHENTICATION:
      return {
        ...state,
        method2FADetails: null
      };
    case actionTypes.authentication.SET_2FA_METHOD_DETAILS:
      return {
        ...state,
        method2FADetails: action.data,
      };
    case actionTypes.authentication.SEND_2FA_CODE:
      return {
        ...state,
        code2FADetails: null,
      };
    case actionTypes.authentication.SEND_2FA_CODE_RESPONSE:
      return {
        ...state,
        code2FADetails: action.data,
      };
    case actionTypes.authentication.CLEAR_2FA_DETAILS:
      return {
        ...state,
        ...initial2FADetailsState
      };
    default:
      return state;
  }
};

export default reducer;
